<template>
  <div>
    <ts-page-title
      :title="$t('leaveInitialBalance.pageTitle')"
      :breadcrumb="[
        { text: $t('home'), href: '/' },
        {
          text: $t('leaveInitialBalance.pageTitle'),
          active: true
        }
      ]"
    />
    <ts-panel>
      <ts-panel-wrapper>
        <div class="ts-flex ts-justify-between">
          <div class="ts-flex">
            <DatePicker
              :value="cycle_year"
              @on-change="onChange"
              format="yyyy"
              type="year"
              style="width: 200px"
              class="ts-px-2"
            />
            <ts-button
              color="primary"
              :waiting="generating"
              class="ts-px-2"
              style="width: 200px"
              @click="generate()"
            >
              {{ $t('leaveInitialBalance.generate') }}</ts-button
            >
          </div>
          <div class="ts-justify-end ts-space-x-2">
            <Input
              search
              v-model="search"
              :placeholder="$t('leaveInitialBalance.search')"
              :style="width"
              @on-focus="() => (width = 'width: 500px')"
              @on-blur="() => (width = 'width: 300px')"
            />
          </div>
        </div>
      </ts-panel-wrapper>
      <div class="overflow-auto">
        <Table
          row-key="index"
          :columns="columns"
          :data="groupResources"
          size="small"
          :loading="loading"
          :span-method="handleSpan"
          highlight-row
          stripe
          max-height="700"
        > 
          <template slot-scope="{ row }" slot="leaveTypeName">
              {{ row.leave_type.leave_type_en }} |
              {{ row.leave_type.leave_type_kh }}
          </template>
          <template slot-scope="{ row }" slot="action">
              <a
                href="#"
                class="text-primary ml-2"
                @click.prevent="onEdit(row)"
                v-tooltip="$t('edit')"
              >
                <Icon type="ios-create" size="20" />
              </a>
          </template>
        </Table>
      </div>
      <div class="ts-flex ts-items-center ts-justify-end ts-p-4">
        <ts-i-pagination
          v-model="pagination"
          @navigate="fetchData"
        ></ts-i-pagination>
      </div>

      <a-modal
        v-model="showForm"
        draggable
        sticky
        scrollable
        :mask="false"
        :footer="null"
        :z-index="1022"
        :closable="true"
        :title="$t('leaveInitialBalance.pageTitle')"
      >
        <from-action
          ref="form_action"
          @cancel="clearEdit"
          @fetchData="fetchData"
        />
      </a-modal>
    </ts-panel>
  </div>
</template>

<script>
import { Errors } from 'form-backend-validation'
import moment from 'moment'
import { debounce } from 'lodash'
import { mapState } from 'vuex'
import FromAction from './form'
import Vue from 'vue'
import ViewUI from 'view-design'
import locale from 'view-design/dist/locale/en-US'
import iTable from '@/store/i-table-helper'
Vue.use(ViewUI, { locale })
Vue.use(ViewUI)

export default {
  name: 'leave-initial-balance',
  components: {
    FromAction
  },
  data () {
    return {
      cycle_year: moment().year().toString(),
      loading: false,
      showForm: false,
      generating: false,
      width: 'width: 300px'
    }
  },
  computed: {
    ...mapState('humanResource/leaveInitialBalance', [
      'resources',
      'pagination'
    ]),
    search: {
      get () {
        return this.$store.state.humanResource.leaveInitialBalance.search
      },
      set (newValue) {
        this.$store.commit(
          'humanResource/leaveInitialBalance/SET_SEARCH',
          newValue
        )
        this.$store.commit(
          'humanResource/leaveInitialBalance/RESET_CURRENT_PAGE'
        )
      }
    },
    groupResources() {
      return iTable.rowGroup(this.resources, 'employee.employee_name_en')
    },
    columns () {
      return [
        {
          key: "column_name",
          tree: true,
          maxWidth: 15,
        },
        {
          title: this.$t('leaveInitialBalance.leaveType'),
          width: 220,
          slot: 'leaveTypeName'
        },
        {
          title: this.$t('leaveInitialBalance.cycleStart'),
          key: 'cycle_start',
          width: 120,
          align: 'center'
        },
        {
          title: this.$t('leaveInitialBalance.cycleStop'),
          key: 'cycle_stop',
          width: 120,
          align: 'center'
        },
        {
          title: this.$t('leaveInitialBalance.carryForwardClearDate'),
          key: 'carry_forward_clear_date',
          width: 200,
          align: 'center'
        },
        {
          title: this.$t('leaveInitialBalance.entitleBalance'),
          key: 'entitle_balance',
          width: 140,
          align: 'center'
        },
        {
          title: this.$t('leaveInitialBalance.incrementDay'),
          key: 'increment_day',
          width: 140,
          align: 'center'
        },
        {
          title: this.$t('leaveInitialBalance.adjustment'),
          key: 'adjustment',
          width: 120,
          align: 'center'
        },
        {
          title: this.$t('leaveInitialBalance.carryForward'),
          width: 160,
          key: 'carry_forward'
        },
        {
          title: this.$t('leaveInitialBalance.carryForwardUsed'),
          key: 'carry_forward_used',
          width: 160,
          align: 'center'
        },
        {
          title: this.$t('leaveInitialBalance.carryForwardCleared'),
          width: 180,
          key: 'carry_forward_cleared'
        },
        {
          title: this.$t('actions'),
          key: 'action',
          slot: 'action',
          fixed: 'right',
          align: 'center',
          width: 94
        }
      ]
    }
  },
  methods: {
    onChange (data) {
      this.cycle_year = data
    },
    fetchData (attributes) {
      this.loading = true
      this.$store
        .dispatch('humanResource/leaveInitialBalance/fetch', {
          cycle_year: this.cycle_year,
          ...attributes
        })
        .then(() => {
          this.loading = false
        })
        .catch(error => {
          this.loading = false
          this.notice({ type: 'error', text: error.message })
        })
    },
    generate () {
      this.generating = true
      this.$store
        .dispatch('humanResource/leaveInitialBalance/generate', {
          cycle_year: this.cycle_year
        })
        .then(response => {
          this.notice({
            type: response.message_id == 0 ? 'success' : 'warning',
            text: response.message
          })
          this.fetchData()
        })
        .catch(error => {
          this.errors = new Errors(error.errors)
          this.notice({ type: 'error', text: error.message })
        })
        .finally(() => {
          this.generating = false
        })
    },
    async onEdit (record) {
      this.showForm = true
      await this.$store.commit(
        'humanResource/leaveInitialBalance/SET_EDIT_DATA',
        record
      )
      await this.$refs.form_action.setEditData()
    },
    clearEdit () {
      this.showForm = false
      this.$refs.form_action.setEditData()
      this.$refs.form_action.clearInput()
      this.$store.commit('humanResource/leaveInitialBalance/SET_EDIT_DATA', {})
    },
    handleSpan({ row, column, rowIndex, columnIndex }) {
      return iTable.handleSpan(row, columnIndex, this.columns)
    },
    notice (not) {
      this.$Notice[not.type]({
        title: 'LEAVE INITIAL BALANCE',
        desc: not.text
      })
    }
  },
  watch: {
    search: debounce(function (search) {
      this.fetchData({ search, cycle_year: this.cycle_year })
    }, 500),
    cycle_year: function (cycleYear) {
      this.fetchData({ cycle_year: cycleYear })
    }
  },
  beforeRouteLeave (to, from, next) {
    this.$store.commit('humanResource/leaveInitialBalance/RESET_STATE')
    next()
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.fetchData()
    })
  }
}
</script>
